module.exports = __webpack_public_path__ + "../assets/fonts/OpenSans-Bold.50145685042b4df07a1fd19957275b81.ttf";